<script setup lang="ts">
import { computed, toRaw } from 'vue'

import type { TasksKanbanStage as TasksKanbanStageEnum } from '@brighterly/lib-core-types/tasks-kanban/enums'

import { TASKS_KANBAN_STAGE_LABEL } from '@widgets/kanban-comments'
import { KanbanStageHead } from '@shared/ui/kanban'

import { useTasksKanbanStore } from '../model/store'
import TasksKanbanStage from './TasksKanbanStage.vue'
import TasksKanbanStageBody from './TasksKanbanStageBody.vue'
import { TASKS_KANBAN_STAGE_COLOR } from '../config/tasks-kanban-stage-color.const'

defineOptions({
  name: 'TasksKanbanTable',
})

const tasksKanbanStore = useTasksKanbanStore()

const stages = computed(() => {
  const options = toRaw(tasksKanbanStore.getTasks)
  if (!options) return []
  return Object.entries(options).map((item) => {
    return {
      name: item[0] as TasksKanbanStageEnum,
      data: item[1],
    }
  })
})
</script>

<template>
  <div class="tkb-table">
    <TasksKanbanStage
      v-for="stage in stages"
      :key="stage.name"
      :stage="stage.name"
    >
      <template #head>
        <KanbanStageHead
          :text="TASKS_KANBAN_STAGE_LABEL[stage.name]"
          :color="TASKS_KANBAN_STAGE_COLOR[stage.name]"
          :card-count="stage.data.count"
        />
      </template>
      <template #default>
        <TasksKanbanStageBody
          :tasks="stage.data.tasks"
        />
      </template>
    </TasksKanbanStage>
  </div>
</template>

<style scoped lang="scss" src="./TasksKanbanTable.scss" />
